(function(angular) {
    angular.module('bizPartEngage').directive('bizModuleVideoList', bizModuleVideoListDirective);

    bizModuleVideoListDirective.$inject = [];

    function bizModuleVideoListDirective() {
        var directive = {
            restrict: "E",
            scope: {
                settings: "=?"
            },
            templateUrl: function(element, attr) {
                if (attr.templateurl) {
                    return siteRootPath + attr.templateurl;
                } else {
                    return siteRootPath + "FrontEnd/Modules/Media/Views/video-list.html"
                }
            },
            controller: bizModuleVideoListController,
            controllerAs: "vm",
            bindToController: true
        };

        bizModuleVideoListController.$inject = ["$rootScope", "modules.media.service", "$timeout", "$sce"];

        function bizModuleVideoListController($rootScope, mediaService, $timeout, $sce) {
            var vm = this;
            vm.Videos = [];

            vm.Init = Init;

            function InitObjectMiniList() {

                console.log("medialist settings", vm.settings);
                vm.MediaItemsForMiniObjectList = [];

                for (var i = 0; i < vm.Videos.length; i++) {
                    var mediaItem = vm.Videos[i];

                    var miniObject = {
                        Id: mediaItem.Id,
                        Name: mediaItem.Name,
                        Description: mediaItem.Description,
                        ImageUrl: mediaItem.ImageUrl,
                        EngageObjects: [],
                        Url: { state: 'base.modules.mediafile', params: { id: mediaItem.UrlRewrite || mediaItem.Id } }
                    };

                    vm.MediaItemsForMiniObjectList.push(miniObject);
                }
            }

            function Init() {
                if(!vm.settings.Filter && vm.settings.SelectedFilter) vm.settings.Filter = vm.settings.SelectedFilter.Value;
                if(!vm.settings.Limit && vm.settings.SelectedLimit) vm.settings.Limit = vm.settings.SelectedLimit.Value;
                
                if(vm.settings.Filter == 'newest') {
                    mediaService.GetMediaFiles([1], null, null, null).then(GetVideosSuccess);
                }
                else if(vm.settings.Filter == 'journey') {
                    mediaService.GetMediaFiles([1], $rootScope.FavoriteTagIds, null, null, true).then(GetVideosSuccess);
                }

                function GetVideosSuccess(response) {
                    vm.Videos = response.data;

                    InitObjectMiniList();
                }
            }

            vm.$onInit = vm.Init;

            if (angular.version.major === 1 && angular.version.minor < 5) {
                vm.$onInit();
            }
        }

        return directive;
    }
})(window.angular);
